import { Injectable, inject } from '@angular/core'
import { environment } from '@environment'
import { MapboxAPIService } from '@modules/bv-api'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { EMPTY, of } from 'rxjs'
import { catchError, switchMap } from 'rxjs/operators'
import * as BasemapActions from './actions'

@Injectable()
export class BasemapEffects {
  readonly store = inject(Store)
  readonly actions$ = inject(Actions)
  readonly mapboxAPIService = inject(MapboxAPIService)

  InitRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BasemapActions.loadBasemaps),
      switchMap(() =>
        this.mapboxAPIService.getTiles().pipe(
          switchMap((basemaps) => {
            return of(
              BasemapActions.loadBasemapsSuccess({
                basemaps: basemaps.map((x) => ({
                  ...x,
                  iconUrl: `${x.iconUrl}?access_token=${environment.mapboxToken}`,
                })),
              }),
            )
          }),
          catchError(() => EMPTY),
        ),
      ),
    ),
  )
}
